import { Field } from '@payaca/ambrosia';
import { get as _get } from 'lodash-es';
import { FC } from 'react';

import useDeviceSearch from '@/api/rest/connectionApplication/useDeviceSearch';

import {
  LowCarbonTech,
  SearchDevice,
  SupportingLowCarbonTech,
} from '@payaca/types/deviceTypes';
import { sentenceCase } from '@payaca/utilities/stringUtilities';
import type { Props as DynamicField } from './DynamicViewField';
import SearchedDeviceDetailsCard from './SearchedDeviceDetailsCard';

type Props = Omit<DynamicField, 'definitions'> & {
  deviceType: LowCarbonTech | SupportingLowCarbonTech;
  formData: any;
};

const DeviceSearchFieldReadonly: FC<Props> = ({
  name,
  fieldSchema,
  deviceType,
  formData,
}) => {
  const selectedDeviceRef = _get(formData, name);
  const phaseCode = _get(formData, 'supplyDetails.phaseCode');

  const { data: deviceSearchResults } = useDeviceSearch(
    name,
    deviceType,
    selectedDeviceRef,
    phaseCode
  );

  const selectedDevice = deviceSearchResults?.find(
    (x: SearchDevice) => x.reference === selectedDeviceRef
  );

  return (
    <Field.Legacy>
      <div className="space-y-2">
        <Field.Label>
          {sentenceCase(fieldSchema.title)}{' '}
          {fieldSchema.json_schema_extra.required ? '*' : ''}
        </Field.Label>
        <Field.HelperText>
          {fieldSchema.json_schema_extra.tooltip}
        </Field.HelperText>

        <p>{selectedDeviceRef}</p>

        {selectedDevice && (
          <SearchedDeviceDetailsCard selectedDevice={selectedDevice} />
        )}
      </div>
    </Field.Legacy>
  );
};

export default DeviceSearchFieldReadonly;
